import Header from "./components/Header";
import Main from "./components/Main";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      {/* <Navbar /> */}
      <Header />
      <Main />
      <Footer />
    </>
  );
}

export default App;
